import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { createPaymentTerm, editPaymentTerm, resetCreatePaymentTerm, resetEditPaymentTerm } from '../../actions/paymentTerms_actions';
import PaymentTermForm from '../../components/Customers/paymentTermForm';

function mapStateToProps(state) {
  return {
    currentPaymentTerm: state.paymentTerms.currentPaymentTerm,
    initialValues: state.paymentTerms.currentPaymentTerm,
    isCreating: state.paymentTerms.isCreating,
    createError: state.paymentTerms.createError,
    created: state.paymentTerms.created,
    isEditing: state.paymentTerms.isEditing,
    editError: state.paymentTerms.editError,
    edited: state.paymentTerms.edited,
    userPermissions: state.auth.userPermissions,
  };
}

const validate = (values) => {
  const errors = {};
  if (!values.Name) {
    errors.Name = 'Required';
  }
  if (!values.TermDays) {
    errors.TermDays = 'Required';
  } else if (isNaN(Number(values.TermDays))) {
    errors.TermDays = 'Term Days should be a number.';
  }
  if (!values.Termtype) {
    errors.Termtype = 'Required';
  }
  return errors;
};

const paymentTermForm = reduxForm({
  form: 'paymentTermForm',
  validate,
})(PaymentTermForm);

export default connect(mapStateToProps, {
  createPaymentTerm, editPaymentTerm, resetCreatePaymentTerm, resetEditPaymentTerm,
})(paymentTermForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Customers/paymentTermForm.jsx